import React from "react"

import GatsbyStoryblokImage from "./GatsbyStoryblokImage"
import LayoutItem from "../../V2/Layouts/LayoutItem"

type Props = {
  imageUrl: string
  imageAlt: string
  mobileGridOrder?: number
}

const ArticleImage = ({ imageUrl, imageAlt, mobileGridOrder }: Props) => {
  return (
    <LayoutItem
      mobileGridOrder={mobileGridOrder}
      as={GatsbyStoryblokImage}
      aspectRatio="16:9"
      loadType="eager"
      image={imageUrl}
      alt={imageAlt || "Article image"}
      rounded
      className="w-full"
    />
  )
}

export default ArticleImage
